/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogCustomEventUrlResponse
 */
export interface LogCustomEventUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof LogCustomEventUrlResponse
     */
    redirectUrl: string;
}

/**
 * Check if a given object implements the LogCustomEventUrlResponse interface.
 */
export function instanceOfLogCustomEventUrlResponse(value: object): value is LogCustomEventUrlResponse {
    if (!('redirectUrl' in value) || value['redirectUrl'] === undefined) return false;
    return true;
}

export function LogCustomEventUrlResponseFromJSON(json: any): LogCustomEventUrlResponse {
    return LogCustomEventUrlResponseFromJSONTyped(json, false);
}

export function LogCustomEventUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogCustomEventUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUrl': json['redirectUrl'],
    };
}

export function LogCustomEventUrlResponseToJSON(json: any): LogCustomEventUrlResponse {
    return LogCustomEventUrlResponseToJSONTyped(json, false);
}

export function LogCustomEventUrlResponseToJSONTyped(value?: LogCustomEventUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectUrl': value['redirectUrl'],
    };
}

